module.exports = __webpack_public_path__ + "r.no1.387a5618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/r.no1.jpg
// module id = /niW
// module chunks = 0